import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "../../../app/axios";
import { API_URL } from "../../../app/config";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IAdminSettingDetails } from "../adminsettingModel";

export const updateAdminSettings = createAsyncThunk(
  "AdminSettings/InsertAdminSettings",
  async (UserData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/AdminSettings/InsertAdminSettings`,
        UserData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating user:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAdminSettings = createAsyncThunk(
  "AdminSettings/GetAdminSettings",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/AdminSettings/GetAdminSettings`
      );
      const result = response.data?.Data as any;
      return {
        GST: result?.GST || 0,
        TCSLimit: result?.TCSLimit || 0,
        TCSUnderPer: result?.TCSUnderPer || 0,
        TCSOverPer: result?.TCSOverPer || 0,
        FollowupRemienderHrs: result?.FollowupRemienderHrs || 0,
        Dom_Quot_TermsNCondition: result?.Dom_Quot_TermsNCondition || "",
        Int_Quot_TermsNCondition: result?.Int_Quot_TermsNCondition || "",
        Dom_FIT_TermsNCondition: result?.Dom_FIT_TermsNCondition || "",
        Int_FIT_TermsNCondition: result?.Int_FIT_TermsNCondition || "",
        FlightTermsAndCondition: result?.FlightTermsAndCondition || "",
        HotelTermsAndCondition: result?.HotelTermsAndCondition || "",
        VisaTermsAndCondition: result?.VisaTermsAndCondition || "",
      } as IAdminSettingDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching handling fee details:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
